<template>
  <div class="search-panel">
    <div class="search-box">
      <input type="text" placeholder="搜索" v-model="searchStr" @input="search" @focus="search" @blur="blurEvent" />
      <t-icon name="search" class="ic-search" size="20px" />
    </div>
    <div class="search-result" v-if="showResult">
      <div class="result-main" v-if="resultList.length">
        <div v-for="(result, index) in resultList" :key="index">
          <div class="result-tt">
            <span>{{ result.title }}</span>
            <template v-if="result.content">
              | <span>{{ result.content }}</span></template
            >
          </div>
          <div class="result-cont" @click="toSearchResult(result)">
            <span>{{ result.value }}</span>
          </div>
        </div>
      </div>
      <div v-else class="result-main result-empty">暂无搜索结果</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'searchPanel',
  computed: {
    ...mapState('doc', ['spaceInfo', 'categoryInfo', 'docInfo']),
  },
  inject: ['reload'],
  data() {
    return {
      searchStr: '',
      resultList: [],
      showResult: false,
    };
  },
  methods: {
    search() {
      if (this.searchStr.length > 1) {
        this.showResult = true;
        this.resultList = [];
        const searchStr = this.searchStr.toLowerCase();
        Object.keys(this.docInfo).forEach((key) => {
          const docInfo = this.docInfo[key].html;
          const contentStr = docInfo.replaceAll(/<([\s\S]*?)>|<\/([\s\S]*?)>/g, '');
          // 包含html标签字符的搜索结果的索引集合
          const [...idxList] = docInfo.toLowerCase().matchAll(searchStr);
          // 只有文本内容的搜索结果的索引集合
          const [...contentList] = contentStr.toLowerCase().matchAll(searchStr);
          // 获取搜索结果前面h标签的索引
          //这里获取的匹配字符的最近一个h标签不一定都是正确的，因为有可能匹配了html标签，比如搜索h2不应该搜到<h2>，这里先记录，后面进行筛选
          const tempHdomList = this.getTempIdList({ idxList, contentStr, docInfo });
          this.setResultList({ contentList, tempHdomList, contentStr, key });
        });
      } else {
        this.showResult = false;
      }
    },
    getTempIdList({ idxList, contentStr, docInfo }) {
      const tempHdomList = [];
      idxList.forEach((element) => {
        // 获取匹配字符前面所有的h标签
        const idx = element.index;
        const result = docInfo.substring(0, idx).match(/<h([1-6]{1})[^>]*>([\s\S]*?)/g);
        // 获取匹配字符前面最近的一个h标签
        const lastH = result?.pop();
        // 获取h标签的id
        const id = lastH?.match(/id="([^"]+)"/)?.[1];
        const content = lastH?.match(/content="([^"]+)"/)?.[1];
        if (id) {
          tempHdomList.push({
            content,
            domId: id,
            index: contentStr.indexOf(id),
          });
        }
      });
      return tempHdomList;
    },
    setResultList({ contentList, tempHdomList, contentStr, key }) {
      contentList.forEach((element) => {
        // 搜索结果的索引
        const contentIdx = element.index;
        // 搜索结果前面最近一个h标签的索引
        const trueHIdx = tempHdomList.findIndex((item) => item.index > contentIdx);
        // 搜索结果前面最近一个h标签
        const trueHdomItem =
          trueHIdx !== -1 ? tempHdomList[Math.max(0, trueHIdx - 1)] : tempHdomList[tempHdomList.length - 1];
        const pageInfo = this.findPageInfoById(key, this.categoryInfo);
        if (!pageInfo || pageInfo.title.includes('测试')) return;
        this.resultList.push({
          nav: trueHdomItem?.domId,
          content: trueHdomItem?.content,
          value: `···${contentStr.substring(contentIdx - 10, contentIdx + 10)}···`,
          title: pageInfo?.title,
          titleId: pageInfo.id,
        });
      });
    },
    findPageInfoById(key, array) {
      let result;
      array.find((item) => {
        if(!item.has_children) {
          const isMatch = String(item.id) === String(key);
          if (isMatch) {
            result = item;
          }
          return isMatch;
        }
        result = this.findPageInfoById(key, item.childrens);
        return result;
      });
      return result;
    },
    toSearchResult(result) {
      const curRout = decodeURIComponent(this.$route.fullPath);
      let link = `/?id=${result.titleId}`;
      if (result.nav) {
        link += `#${result.nav}`;
      }
      this.$router.push(link);
      if (curRout === link) {
        this.reload();
      }
      this.showResult = false;
    },
    reset() {
      this.searchStr = '';
      this.resultList = [];
    },
    blurEvent() {
      setTimeout(() => {
        this.showResult = false;
      }, 100);
    },
  },
};
</script>
<style scoped>
.search-panel {
  position: relative;
}
.search-box {
  position: relative;
  font-size: 0;
}
.search-box input {
  width: 250px;
  height: 30px;
  border: 1px solid #aaa;
  text-indent: 30px;
  padding: 0;
  max-width: 55vw;
}
.search-box input:focus {
  border-color: #0052d9;
}
.search-box .ic-search {
  position: absolute;
  left: 5px;
  top: 6px;
}
.search-result {
  position: absolute;
  top: 100%;
  right: 0;
  background-color: #fff;
  border: 1px solid #aaa;
  font-size: 12px;
}
.search-result .result-main {
  padding: 8px;
  min-width: 300px;
  max-height: 200px;
  max-width: 500px;
  overflow-y: scroll;
}
.search-result .result-empty {
  text-align: center;
}
.search-result .result-tt {
  background-color: #0052d9;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 10px;
}
.search-result .result-cont {
  cursor: pointer;
}
.search-result .result-cont:hover {
  background-color: #eee;
}
</style>
